/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Groups_Users_DeleteInputs */

const fr_groups_users_delete = /** @type {((inputs: Groups_Users_DeleteInputs) => LocalizedString) & { parts: (inputs: Groups_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Groups_Users_DeleteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Êtes vous sûre de vouloir supprimer l'utilisateur
${i?.name} ?

Celui perdra l'accès à tous les bâtiments de son groupe et des groupes enfants.`)
		}),
		{
			parts: /** @type {(inputs: Groups_Users_DeleteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Êtes vous sûre de vouloir supprimer l'utilisateur\n" }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.name) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: " ?\n\nCelui perdra l'accès à tous les bâtiments de son groupe et des groupes enfants." }])
			})
		}
	)
);

const en_groups_users_delete = /** @type {((inputs: Groups_Users_DeleteInputs) => LocalizedString) & { parts: (inputs: Groups_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Groups_Users_DeleteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Are you sure you want to delete the user
${i?.name}?

They will lose access to all buildings in their group and child groups.`)
		}),
		{
			parts: /** @type {(inputs: Groups_Users_DeleteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Are you sure you want to delete the user\n" }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.name) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: "?\n\nThey will lose access to all buildings in their group and child groups." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Are you sure you want to delete the user {name}? They will lose access to all buildings in their group and child groups." |
*
* @param {Groups_Users_DeleteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const groups_users_delete = /** @type {((inputs: Groups_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Groups_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Groups_Users_DeleteInputs, { locale?: "fr" | "en" }, { span: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Groups_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_groups_users_delete(inputs)
			return fr_groups_users_delete(inputs)
		}),
		{
			parts: /** @type {(inputs: Groups_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Groups_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (en_groups_users_delete).parts?.(inputs) ?? [{ type: "text", value: en_groups_users_delete(inputs) }]
				return /** @type {{ parts?: (inputs: Groups_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (fr_groups_users_delete).parts?.(inputs) ?? [{ type: "text", value: fr_groups_users_delete(inputs) }]
			})
		}
	)
);